import React from 'react';
import {createBrowserRouter, createRoutesFromElements, Navigate, Route} from "react-router-dom";
import {BaseLayout} from "layouts/BaseLayout";
import MainPage from './pages/MainPage';
import PaymentStatus from './pages/PaymentStatus';

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route
                element={<BaseLayout/>}
            >
                <Route path="/" element={<Navigate to="/ru" replace/>}/>
                <Route path="/:lang" element={<MainPage/>}/>
                <Route path="/:lang/payment/success" element={<PaymentStatus status="success"/>}/>
                <Route path="/:lang/payment/failed" element={<PaymentStatus status="failed"/>}/>
                <Route path="*" element={<MainPage/>}/>
            </Route>
        </>,
    ),
);